export const getPrimaryBtnText = (
  status: string | undefined,
  tab: string
): string | null => {
  switch (status) {
    case 'PENDING':
      return 'Samþykkja';

    case 'AUTHORIZED':
      if (tab === 'kostnadur') {
        return 'Áfram';
      } else {
        return 'Klára skráningu';
      }
    case 'COST_REVISIT':
      return 'Klára skráningu';
    case 'COST_APPROVED':
    case 'COST_IN_REVIEW':
      return 'Endurskoða kostnað';
    case 'COST_REVIEWED':
    case 'COST_CONFIRMED':
      return 'Staðfesta kostnað';
    default:
      return null;
  }
};

export const getSecondaryBtnVariant = (
  status: string | undefined
): 'primary' | 'secondary' | 'warning' => {
  return status === 'PENDING' ||
    status === 'COST_REVIEWED' ||
    status === 'COST_CONFIRMED'
    ? 'warning'
    : 'secondary';
};

export const getSecondaryBtnText = (status: string | undefined): string => {
  if (status === 'PENDING') {
    return 'Hafna';
  } else if (status === 'COST_REVIEWED' || status === 'COST_CONFIRMED') {
    return 'Endurskoðun';
  } else if (status === 'AUTHORIZED') {
    return 'Halda áfram síðar';
  } else {
    return 'Til baka';
  }
};
